/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/pl';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Uzyskaj dostęp do ulepszonego edytora HTML"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Kontrola dostępności"
  },
  "action_to_take_b626a99a": {
    "message": "Wymagane działanie:"
  },
  "add_8523c19b": {
    "message": "Dodaj"
  },
  "add_a_caption_2a915239": {
    "message": "Dodaj napis"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Dodaj alternatywny tekst dla obrazka"
  },
  "add_another_f4e50d57": {
    "message": "Dodaj kolejne"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Dodaj CC/napisy"
  },
  "add_image_60b2de07": {
    "message": "Dodaj zdjęcie"
  },
  "add_one_9e34a6f8": {
    "message": "Dodaj jedną!"
  },
  "additional_considerations_f3801683": {
    "message": "Dodatkowe kwestie"
  },
  "address_applied_64269b0b": {
    "message": "Zastosowano adres"
  },
  "address_removed_fcb496e0": {
    "message": "Usunięto adres"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Sąsiadujące łącza o tym samym adresie URL powinny stanowić pojedyncze łącze."
  },
  "aleph_f4ffd155": {
    "message": "Alef"
  },
  "align_11050992": {
    "message": "Dostosuj"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Wyrównanie i listy"
  },
  "all_4321c3a1": {
    "message": "Wszystkie"
  },
  "all_apps_a50dea49": {
    "message": "Wszystkie aplikacje"
  },
  "allow_media_download_16dcf2bd": {
    "message": "Zezwól na pobieranie multimediów"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "Zezwól na pobieranie transkrypcji"
  },
  "alpha_15d59033": {
    "message": "Alfa"
  },
  "alphabetical_55b5b4e0": {
    "message": "Alfabetycznie"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Alternatywny tekst nie może zawierać więcej niż 120 znaków."
  },
  "alt_text_611fb322": {
    "message": "Alternatywny tekst"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (suma)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Wystąpił błąd podczas odczytywania pliku"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Wystąpił błąd podczas przesyłania żądania sieciowego"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Podczas wysyłania multimediów wystąpił błąd."
  },
  "and_7fcc2911": {
    "message": "Oraz"
  },
  "angle_c5b4ec50": {
    "message": "Kąt"
  },
  "announcement_fb4cb645": {
    "message": "Ogłoszenie"
  },
  "announcement_list_da155734": {
    "message": "Lista ogłoszeń"
  },
  "announcements_a4b8ed4a": {
    "message": "Ogłoszenia"
  },
  "apply_781a2546": {
    "message": "Zastosuj"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Zastosuj zmiany do wszystkich instancji tej ikony Icon Maker w kursie"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Zbliża się do granicy"
  },
  "approximately_e7965800": {
    "message": "W przybliżeniu"
  },
  "apps_54d24a47": {
    "message": "Aplikacje"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Czy na pewno chcesz anulować? Zmiany mogą nie zostać zapisane."
  },
  "arrows_464a3e54": {
    "message": "Strzałki"
  },
  "art_icon_8e1daad": {
    "message": "Ikona sztuki"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Współczynnik proporcji zostanie zachowany"
  },
  "assignment_976578a8": {
    "message": "Zadanie"
  },
  "assignments_1e02582c": {
    "message": "Zadania"
  },
  "asterisk_82255584": {
    "message": "Gwiazdka"
  },
  "attributes_963ba262": {
    "message": "Właściwości"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Nagrywanie dźwięku i wideo nie jest obsługiwane; użyj innej przeglądarki."
  },
  "audio_options_feb58e2c": {
    "message": "Opcje audio"
  },
  "audio_options_tray_33a90711": {
    "message": "Panel opcji audio"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Odtwarzacz audio dla { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Istnieje automatycznie zapisana zawartość. Czy wolisz wczytać automatyczną zawartość?"
  },
  "available_folders_694d0436": {
    "message": "Dostępne foldery"
  },
  "background_1bc88842": {
    "message": "Tło"
  },
  "backslash_b2d5442d": {
    "message": "Ukośnik lewy"
  },
  "bar_ec63ed6": {
    "message": "Kreska"
  },
  "basic_554cdc0a": {
    "message": "Podstawowy"
  },
  "because_501841b": {
    "message": "Ponieważ"
  },
  "below_81d4dceb": {
    "message": "Poniżej"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Duży okrąg"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Współczynnik dwumianowy"
  },
  "black_4cb01371": {
    "message": "Czarny"
  },
  "blue_daf8fea9": {
    "message": "Niebieski"
  },
  "bold_applied_42d547b7": {
    "message": "Zastosowano pogrubienie"
  },
  "bold_removed_da474a5c": {
    "message": "Usunięto pogrubienie"
  },
  "border_5b08b06d": {
    "message": "Obramowanie"
  },
  "bottom_15a2a9be": {
    "message": "Dół"
  },
  "bottom_third_5f5fec1d": {
    "message": "Trzeci od dołu"
  },
  "bowtie_5f9629e4": {
    "message": "Muszka"
  },
  "brick_f2656265": {
    "message": "Cegła"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Anuluj"
  },
  "cap_product_3a5265a6": {
    "message": "G mnożenie"
  },
  "caption_manager_aae0906f": {
    "message": "Menedżer napisów"
  },
  "center_align_e68d9997": {
    "message": "Wyśrodkuj"
  },
  "centered_dot_64d5e378": {
    "message": "Kropka wyśrodkowana"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Wyśrodkowane kropki poziomo"
  },
  "change_alt_text_92654906": {
    "message": "Zmień alternatywny tekst"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Zmień tag nagłówka na akapit"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Zmień tylko ten poziom nagłówka"
  },
  "change_text_color_1aecb912": {
    "message": "Zmień kolor tekstu"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "Zmiany zostaną zastosowane, gdy opuścisz tę stronę."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Zmiany mogą nie zostać zapisane."
  },
  "characters_9d897d1c": {
    "message": "Znaki"
  },
  "characters_no_spaces_485e5367": {
    "message": "Znaki (bez spacji)"
  },
  "check_accessibility_3c78211c": {
    "message": "Sprawdź dostępność"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Sprawdź problemy z dostępnością"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Wybierz plik z napisami"
  },
  "choose_usage_rights_33683854": {
    "message": "Wybierz prawa użytkowania..."
  },
  "circle_484abe63": {
    "message": "Okrąg"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "oznacz nieuporządkowaną listę"
  },
  "clear_2084585f": {
    "message": "Wyczyść"
  },
  "clear_image_3213fe62": {
    "message": "Wyczyść obraz"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Kliknij lub naciśnij Shift i kliknij, aby otworzyć edytor html."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Kliknij, aby osadzić { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Kliknij, aby ukryć podgląd"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Kliknij, aby wstawić łącze do edytora."
  },
  "click_to_show_preview_faa27051": {
    "message": "Kliknij, aby wyświetlić podgląd"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Zamknij menu lub okno dialogowe. Przywraca do obszaru edytora"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Zamknij kontrolę dostępności"
  },
  "close_d634289d": {
    "message": "Zamknij"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "Zamknij okno skrótów klawiszowych"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "Plik z napisami musi być mniejszy niż { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Napisy / napisy dla niesłyszących"
  },
  "clubs_suit_c1ffedff": {
    "message": "Trefle (kolor)"
  },
  "collab_575ac7bc": {
    "message": "Współpraca"
  },
  "collaborations_5c56c15f": {
    "message": "Współprace"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Kliknij, aby ukryć { types }"
  },
  "color_a363e1b0": {
    "message": "Kolorowy"
  },
  "color_contrast_4c418add": {
    "message": "Kontrastu koloru"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Współczynnik kontrastu koloru"
  },
  "color_picker_6b359edf": {
    "message": "Narzędzie wyboru kolorów"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Narzędzie wyboru kolorów (wybrano { colorName })"
  },
  "color_popup_af39810f": {
    "message": "Kolorowy komunikat"
  },
  "column_e1ae5c64": {
    "message": "Kolumna"
  },
  "column_group_1c062368": {
    "message": "Grupa kolumn"
  },
  "complex_numbers_a543d004": {
    "message": "Liczby zespolone"
  },
  "computer_1d7dfa6f": {
    "message": "Komputer"
  },
  "congruent_5a244acd": {
    "message": "Przystające"
  },
  "contains_311f37b7": {
    "message": "Zawiera"
  },
  "content_1440204b": {
    "message": "Zawartość"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Zawartość w edytorze ulegnie zmianie. Naciśnij Anuluj, aby zachować pierwotną zawartość."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Zawartość jest nadal przesyłana; w przypadku kontynuowania obraz nie zostanie prawidłowo osadzony."
  },
  "content_subtype_5ce35e88": {
    "message": "Podtyp zawartości"
  },
  "content_type_2cf90d95": {
    "message": "Typ zawartości"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Przejdź do zawartości YouTube."
  },
  "coproduct_e7838082": {
    "message": "Suma"
  },
  "copyright_holder_66ee111": {
    "message": "Właściciel praw autorskich:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Nie można wstawić zawartości: Elementy obecnie nieobsługiwane w Canvas: \"{ itemType }\"."
  },
  "count_40eced3b": {
    "message": "Liczba"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 słów}\n    one {1 słowo}\n  other {# słowa}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# element przesłany}\n  other {# elementów przesłanych}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Dokumenty kursu"
  },
  "course_files_62deb8f8": {
    "message": "Pliki kursu"
  },
  "course_files_a31f97fc": {
    "message": "Pliki kursu"
  },
  "course_images_f8511d04": {
    "message": "Obrazy kursu"
  },
  "course_link_b369426": {
    "message": "Łącze kursu"
  },
  "course_links_b56959b9": {
    "message": "Łącza kursu"
  },
  "course_media_ec759ad": {
    "message": "Multimedia kursu"
  },
  "course_navigation_dd035109": {
    "message": "Nawigowanie po kursie"
  },
  "create_icon_110d6463": {
    "message": "Utwórz ikonę"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Utwórz ikonę Icon Maker"
  },
  "creative_commons_license_725584ae": {
    "message": "Licencja Creative Commons:"
  },
  "crop_image_41bf940c": {
    "message": "Przytnij obraz"
  },
  "crop_image_807ebb08": {
    "message": "Przytnij obraz"
  },
  "cup_product_14174434": {
    "message": "Iloczyn kartezjański"
  },
  "current_image_f16c249c": {
    "message": "Bieżący obraz"
  },
  "current_link_945a47ee": {
    "message": "Bieżące łącze"
  },
  "current_volume_level_c55ab825": {
    "message": "Bieżący poziom głośności"
  },
  "custom_6979cd81": {
    "message": "Niestandardowe"
  },
  "cyan_c1d5f68a": {
    "message": "Cyjan"
  },
  "dagger_57e0f4e5": {
    "message": "Krzyżyk"
  },
  "date_added_ed5ad465": {
    "message": "Data dodania"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Ikona dekoracyjna"
  },
  "decorative_image_fde98579": {
    "message": "Obraz dekoracyjny"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Dekoracyjny { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "Zmniejsz wcięcie"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Zmniejsz obszar zawartości formatowanej"
  },
  "deep_purple_bb3e2907": {
    "message": "Głęboki fiolet"
  },
  "default_9db103d": {
    "message": "Domyślna"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "domyślna nieuporządkowana lista wypunktowana"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "domyślna uporządkowana lista numeryczna"
  },
  "definite_integral_fe7ffed1": {
    "message": "Całka oznaczona"
  },
  "degree_symbol_4a823d5f": {
    "message": "Symbol stopnia"
  },
  "delimiters_4db4840d": {
    "message": "Ograniczniki"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(opisz ikonę)"
  },
  "describe_the_type_ff448da5": {
    "message": "(opisz { TYPE })"
  },
  "description_436c48d7": {
    "message": "Opis"
  },
  "details_98a31b68": {
    "message": "Szczegóły"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Kropki po przekątnej"
  },
  "diamond_b8dfe7ae": {
    "message": "Diament"
  },
  "diamonds_suit_526abaaf": {
    "message": "Karo (kolor)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Typ wymiaru"
  },
  "directionality_26ae9e08": {
    "message": "Kierunkowość"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Edytuj bezpośrednio w LaTeX"
  },
  "disable_preview_222bdf72": {
    "message": "Wyłącz podgląd"
  },
  "discussion_6719c51d": {
    "message": "Dyskusja"
  },
  "discussions_a5f96392": {
    "message": "Dyskusje"
  },
  "discussions_index_6c36ced": {
    "message": "Spis dyskusji"
  },
  "disjoint_union_e74351a8": {
    "message": "Suma rozłączna"
  },
  "display_options_315aba85": {
    "message": "Opcje wyświetlania"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Wyświetl łącze tekstowe (otwiera się w nowej karcie)"
  },
  "div_applied_49ad83fc": {
    "message": "Zastosowano podział"
  },
  "div_removed_d13f8e17": {
    "message": "Usunięto podział"
  },
  "division_sign_72190870": {
    "message": "Znak dzielenia"
  },
  "document_678cd7bf": {
    "message": "Dokument"
  },
  "documents_81393201": {
    "message": "Dokumenty"
  },
  "done_54e3d4b6": {
    "message": "Gotowe"
  },
  "double_dagger_faf78681": {
    "message": "Podwójny krzyż"
  },
  "down_5831a426": {
    "message": "W dół"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Strzałka po przekątnej w dół i w lewo"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Strzałka po przekątnej w dół i w prawo"
  },
  "download_filename_2baae924": {
    "message": "Pobierz { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Strzałka w dół"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Trójkąt skierowany w dół"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Przeciągnij plik tutaj"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Przeciągnij i upuść lub kliknij, aby przeglądać komputer"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Przeciągnij uchwyt. Użyj strzałek w dół i w górę, aby zmienić rozmiar"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Termin: Wiele dat"
  },
  "due_when_7eed10c6": {
    "message": "Termin: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Edytuj tekst alternatywny dla tej instancji ikony"
  },
  "edit_c5fbea07": {
    "message": "Edytuj"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Edytuj łącze do kursu"
  },
  "edit_equation_f5279959": {
    "message": "Edytuj równanie"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Edytuj istniejącą ikonę Icon Maker"
  },
  "edit_icon_2c6b0e91": {
    "message": "Ikona edycji"
  },
  "edit_link_7f53bebb": {
    "message": "Edytuj łącze"
  },
  "editor_status_bar_653f44ee": {
    "message": "Pasek stanu edytora"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Element rozpoczynający się od { start }"
  },
  "embed_828fac4a": {
    "message": "Osadź"
  },
  "embed_code_314f1bd5": {
    "message": "Osadź kod"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Osadź zawartość z zewnętrznego narzędzia"
  },
  "embed_image_1080badc": {
    "message": "Osadź obraz"
  },
  "embed_video_a97a64af": {
    "message": "Osadź wideo"
  },
  "embedded_content_aaeb4d3d": {
    "message": "osadzona zawartość"
  },
  "empty_set_91a92df4": {
    "message": "Pusty zestaw"
  },
  "encircled_dot_8f5e51c": {
    "message": "Kropka w okręgu"
  },
  "encircled_minus_72745096": {
    "message": "Minus w okręgu"
  },
  "encircled_plus_36d8d104": {
    "message": "Plus w okręgu"
  },
  "encircled_times_5700096d": {
    "message": "Znak mnożenia w okręgu"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Ikona inżynierii"
  },
  "english_icon_25bfe845": {
    "message": "Ikona angielskiego"
  },
  "enter_a_media_title_81b490ec": {
    "message": "Wpisz tytuł multimediów"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Wpisz co najmniej 3 znaki, aby wyszukać."
  },
  "enter_replacement_text_17631bbc": {
    "message": "Wpisz tekst zastępczy"
  },
  "enter_search_text_26cb4459": {
    "message": "Wpisz tekst do wyszukania"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (wariant)"
  },
  "equals_sign_c51bdc58": {
    "message": "Znak równości"
  },
  "equation_1c5ac93c": {
    "message": "Równanie"
  },
  "equation_editor_39fbc3f1": {
    "message": "Edytor równań"
  },
  "equilibrium_6ff3040b": {
    "message": "Równowaga"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Klasa równoważności"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Równoważność (identyczność)"
  },
  "eta_b8828f99": {
    "message": "ETA"
  },
  "exists_2e62bdaa": {
    "message": "Istnieje"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Zamknij tryb pełnoekranowy"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Domyślnie rozwiń podgląd"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Rozszerz, aby zobaczyć { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Łącze zewnętrzne"
  },
  "external_tool_frame_70b32473": {
    "message": "Ramy narzędzia zewnętrznego"
  },
  "external_tools_6e77821": {
    "message": "Narzędzia zewnętrzne"
  },
  "extra_large_b6cdf1ff": {
    "message": "Wyjątkowo duże"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "Bardzo duże ({ width } x { height }px)"
  },
  "extra_small_9ae33252": {
    "message": "Bardzo małe"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Ikona zajęć pozalekcyjnych"
  },
  "f_function_fe422d65": {
    "message": "F (funkcja)"
  },
  "fail_544e5dde": {
    "message": "NIEPOWODZENIE"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Nie udało się pobrać zawartości pliku"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Nie udało się pobrać zawartości z zewnętrznego narzędzia"
  },
  "file_name_8fd421ff": {
    "message": "Nazwa pliku"
  },
  "file_preview_21667a6e": {
    "message": "Podgląd pliku"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Podgląd pliku { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Przekroczono przydział magazynowania plików"
  },
  "file_url_c12b64be": {
    "message": "Adres URL pliku"
  },
  "filename_file_icon_602eb5de": {
    "message": "Ikona pliku { filename }"
  },
  "filename_image_preview_6cef8f26": {
    "message": "Podgląd obrazu { filename }"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "Podgląd tekstu { filename }"
  },
  "files_c300e900": {
    "message": "Pliki"
  },
  "files_index_af7c662b": {
    "message": "Wykaz plików"
  },
  "find_8d605019": {
    "message": "Znajdź"
  },
  "find_and_replace_6e345933": {
    "message": "Znajdź i zamień"
  },
  "finish_bc343002": {
    "message": "Zakończ"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Przypnij hierarchię nagłówków"
  },
  "flat_music_76d5a5c3": {
    "message": "Bemol (muzyka)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Pasek opcji koncentracji na elemencie"
  },
  "folder_tree_fbab0726": {
    "message": "Drzewo folderów"
  },
  "for_all_b919f972": {
    "message": "Dla wszystkich"
  },
  "format_4247a9c5": {
    "message": "Format"
  },
  "format_as_a_list_142210c3": {
    "message": "Formatuj jako listę"
  },
  "formatting_5b143aa8": {
    "message": "Formatowanie"
  },
  "forward_slash_3f90f35e": {
    "message": "Ukośnik prawy"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Odnaleziono automatycznie zapisaną zawartość"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Odnaleziono { count, plural,\n     =0 {# wyników}\n    one {# wynik}\n  other {# wyników}\n}"
  },
  "fraction_41bac7af": {
    "message": "Ułamek"
  },
  "fullscreen_873bf53f": {
    "message": "Pełny ekran"
  },
  "gamma_1767928": {
    "message": "Gamma"
  },
  "generating_preview_45b53be0": {
    "message": "Generowanie podglądu..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "Obrazy w formacie GIF/PNG większe niż { size } kB nie są obecnie obsługiwane."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Przejdź do paska menu edytora"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Przejdź do paska narzędzi edytora"
  },
  "grades_a61eba0a": {
    "message": "Oceny"
  },
  "graphics_text_bc9568bc": {
    "message": "Tekst do grafiki"
  },
  "greater_than_e98af662": {
    "message": "Większe niż"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Większe lub równe"
  },
  "greek_65c5b3f7": {
    "message": "Greckie"
  },
  "green_15af4778": {
    "message": "Zielony"
  },
  "grey_a55dceff": {
    "message": "Szary"
  },
  "group_documents_8bfd6ae6": {
    "message": "Grupuj dokumenty"
  },
  "group_files_4324f3df": {
    "message": "Pliki grupy"
  },
  "group_files_82e5dcdb": {
    "message": "Pliki grupy"
  },
  "group_images_98e0ac17": {
    "message": "Grupuj zdjęcia"
  },
  "group_isomorphism_45b1458c": {
    "message": "Izomorfizm grup"
  },
  "group_link_63e626b3": {
    "message": "Łącze grupowe"
  },
  "group_links_9493129e": {
    "message": "Łącza grupowe"
  },
  "group_media_2f3d128a": {
    "message": "Grupuj multimedia"
  },
  "group_navigation_99f191a": {
    "message": "Nawigowanie po grupach"
  },
  "h_bar_bb94deae": {
    "message": "Przekreślone h"
  },
  "hat_ea321e35": {
    "message": "Kapelusz"
  },
  "header_column_f27433cb": {
    "message": "Kolumna nagłówka"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Wiersz i kolumna nagłówka"
  },
  "header_row_f33eb169": {
    "message": "Wiersz nagłówka"
  },
  "heading_2_5b84eed2": {
    "message": "Nagłówek 2"
  },
  "heading_3_2c83de44": {
    "message": "Nagłówek 3"
  },
  "heading_4_b2e74be7": {
    "message": "Nagłówek 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Zastosowano nagłówek { h }"
  },
  "heading_h_removed_745f24a6": {
    "message": "Usunięto nagłówek { h }"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Poziomów nagłówka nie można pomijać."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Nagłówek rozpoczynający się od { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Nagłówki nie powinny zawierać więcej niż 120 znaków."
  },
  "health_icon_8d292eb5": {
    "message": "Ikona zdrowia"
  },
  "hearts_suit_e50e04ca": {
    "message": "Kier (kolor)"
  },
  "height_69b03e15": {
    "message": "Wysokość"
  },
  "hexagon_d8468e0d": {
    "message": "Sześciobok"
  },
  "hide_description_bfb5502e": {
    "message": "Ukryj opis"
  },
  "hide_title_description_caf092ef": {
    "message": "Ukryj opis { title }"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Podkreśl element, aby aktywować pasek narzędzi opcji elementu"
  },
  "home_351838cd": {
    "message": "Strona główna"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "Jak poprosić o napisy i je edytować?"
  },
  "html_code_editor_fd967a44": {
    "message": "edytor kodu html"
  },
  "html_editor_fb2ab713": {
    "message": "Edytor HTML"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Mam uprawnienie do korzystania z tego pliku."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Posiadam prawa autorskie"
  },
  "icon_215a1dc6": {
    "message": "Ikona"
  },
  "icon_8168b2f8": {
    "message": "ikona"
  },
  "icon_color_b86dd6d6": {
    "message": "Kolor ikony"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Ikony Icon Maker"
  },
  "icon_options_7e32746e": {
    "message": "Opcje ikony"
  },
  "icon_options_tray_2b407977": {
    "message": "Panel opcji ikony"
  },
  "icon_preview_1782a1d9": {
    "message": "Podgląd ikony"
  },
  "icon_shape_30b61e7": {
    "message": "Kształt ikony"
  },
  "icon_size_9353edea": {
    "message": "Rozmiar ikony"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Jeśli pozostanie puste, tekst zostanie wyświetlony jako nazwa łącza do kursu"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Jeśli wymagane są prawa użytkowania, plik nie zostanie opublikowany bez wybrania odpowiednich ustawień na stronie Pliki."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Jeśli nie wybierzesz teraz praw do korzystania, po przesłaniu plik nie zostanie opublikowany."
  },
  "image_8ad06": {
    "message": "Zdjęcie"
  },
  "image_c1c98202": {
    "message": "zdjęcie"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Nazw plików obrazu nie można używać jako alternatywnego atrybutu opisującego zawartość obrazu."
  },
  "image_options_5412d02c": {
    "message": "Opcje obrazu"
  },
  "image_options_tray_90a46006": {
    "message": "Panel opcji obrazu"
  },
  "image_to_crop_3a34487d": {
    "message": "Obraz do przycięcia"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Plik obrazu z nazwą { file }"
  },
  "images_7ce26570": {
    "message": "Zdjęcia"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Obrazy powinny obejmować alternatywny atrybut opisujący zawartość obrazu."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Część urojona (liczby zespolonej)"
  },
  "in_element_of_19ca2f33": {
    "message": "W (element)"
  },
  "increase_indent_6af90f7c": {
    "message": "Zwiększ wcięcie"
  },
  "increase_rich_content_area_340b775": {
    "message": "Zwiększ obszar zawartości formatowanej"
  },
  "indefinite_integral_6623307e": {
    "message": "Całka nieoznaczona"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } z { max }"
  },
  "indigo_2035fc55": {
    "message": "Indygo"
  },
  "inference_fed5c960": {
    "message": "Wniosek"
  },
  "infinity_7a10f206": {
    "message": "Nieskończoność"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Pole edycji dla alfa"
  },
  "input_field_for_blue_561e020a": {
    "message": "Pole edycji dla niebieskiego"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Pole edycji dla zielonego"
  },
  "input_field_for_red_86a84615": {
    "message": "Pole edycji dla czerwonego"
  },
  "insert_593145ef": {
    "message": "Wstaw"
  },
  "insert_link_6dc23cae": {
    "message": "Umieść Łącze"
  },
  "insert_math_equation_57c6e767": {
    "message": "Wpisz równanie matematyczne"
  },
  "integers_336344e1": {
    "message": "Liczby całkowite"
  },
  "intersection_cd4590e4": {
    "message": "Część wspólna"
  },
  "invalid_description_991e23bb": {
    "message": "Nieprawidłowy opis"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Nieprawidłowy wpis."
  },
  "invalid_file_c11ba11": {
    "message": "Nieprawidłowy plik"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Nieprawidłowy typ pliku"
  },
  "invalid_url_cbde79f": {
    "message": "Nieprawidłowy adres URL"
  },
  "iota_11c932a9": {
    "message": "Jota"
  },
  "issue_num_total_f94536cf": {
    "message": "Problem { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Zastosowano kursywę"
  },
  "italic_removed_17cbab6f": {
    "message": "Usunięto kursywę"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (wariant)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Skróty klawiaturowe"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Klawiatury pozwalają przejść do łączy za pomocą klawisza Tab. Dwa sąsiednie łącza prowadzącego do tej samej lokalizacji mogą wprowadzać użytkowników klawiatury w błąd."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Ikona języków obcych"
  },
  "languages_icon_9d20539": {
    "message": "Ikona języków"
  },
  "large_9c5e80e7": {
    "message": "Duży"
  },
  "large_text_e7ba08cd": {
    "message": "Duży tekst"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "Duże ({ width } x { height }px)"
  },
  "learn_ad3b3505": {
    "message": "Nauka"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Uzyskaj więcej informacji na temat sąsiadujących linków"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Uzyskaj więcej informacji na temat kontrastu barw"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Uzyskaj więcej informacji na temat organizacji nagłówków na stronie"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Uzyskaj więcej informacji o prawidłowej strukturze nagłówka strony"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Uzyskaj więcej informacji na temat nagłówków tabeli"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Uzyskaj więcej informacji na temat alternatywnego tekstu dla obrazów"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Uzyskaj więcej informacji na temat napisów i tabel"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Uzyskaj więcej informacji na temat nazw plików jako alternatywnego tekstu"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Uzyskaj więcej informacji na temat korzystania z list"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Uzyskaj więcej informacji na temat atrybutów zakresu i tabel"
  },
  "leave_as_is_4facfe55": {
    "message": "Pozostaw jako"
  },
  "left_3ea9d375": {
    "message": "Lewa"
  },
  "left_align_43d95491": {
    "message": "Wyrównaj do lewej"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Lewy nawias ostrokątny"
  },
  "left_arrow_4fde1a64": {
    "message": "Strzałka w lewo"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Strzałka w lewo zawinięta"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Lewy sufit"
  },
  "left_curly_brace_1726fb4": {
    "message": "Lewa klamra okrągła"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Strzała harpuna w lewo w dół"
  },
  "left_floor_29ac2274": {
    "message": "Lewa podłoga"
  },
  "left_to_right_e9b4fd06": {
    "message": "Lewa-prawa"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Strzała harpuna w lewo do góry"
  },
  "leftward_arrow_1e4765de": {
    "message": "Strzałka w lewo"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Trójkąt skierowany w lewo"
  },
  "less_than_a26c0641": {
    "message": "Mniej niż"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Mniejsze lub równe"
  },
  "library_icon_ae1e54cf": {
    "message": "Ikona biblioteki"
  },
  "light_blue_5374f600": {
    "message": "Jasny niebieski"
  },
  "link_7262adec": {
    "message": "Łącze"
  },
  "link_options_a16b758b": {
    "message": "Opcje łącza"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "typ łącza: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Powiąż z tekstem, który się zaczyna od słów { start }"
  },
  "links_14b70841": {
    "message": "Łącza"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Łącza do strony zewnętrznej."
  },
  "lists_cd1336fc": {
    "message": "Listy"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Listy należy sformatować jako listy."
  },
  "load_more_35d33c7": {
    "message": "Wczytaj więcej"
  },
  "loading_25990131": {
    "message": "Wczytywanie..."
  },
  "loading_bde52856": {
    "message": "Wczytywanie"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "Nie udało się wczytać napisów (dla niesłyszących)."
  },
  "loading_external_tool_d839042c": {
    "message": "Wczytywanie narzędzia zewnętrznego"
  },
  "loading_failed_b3524381": {
    "message": "Niepowodzenie wczytywania..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "Niepowodzenie wczytywania."
  },
  "loading_folders_d8b5869e": {
    "message": "Wczytywanie folderów"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Wczytywanie elementu zastępczego dla { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "Ładowanie, proszę czekać"
  },
  "loading_preview_9f077aa1": {
    "message": "Wczytywanie podglądu"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "Zablokuj prędkość na 1x"
  },
  "locked_762f138b": {
    "message": "Zablokowany"
  },
  "logical_equivalence_76fca396": {
    "message": "Równoważność logiczna"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Równoważność logiczna (krótki)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Równoważność logiczna (krótki i pogrubiony)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Równoważność logiczna (pogrubiony)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Niskie kropki poziomo"
  },
  "magenta_4a65993c": {
    "message": "Amarantowy"
  },
  "maps_to_e5ef7382": {
    "message": "Mapy do"
  },
  "math_icon_ad4e9d03": {
    "message": "Ikona matematyki"
  },
  "media_af190855": {
    "message": "Multimedia"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "Trwa przetwarzanie pliku multimediów. Spróbuj ponownie później."
  },
  "media_options_saved_560c4ec8": {
    "message": "Zapisano opcje multimediów."
  },
  "media_title_2112243b": {
    "message": "Tytuł multimediów"
  },
  "medium_5a8e9ead": {
    "message": "Średni"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "Średnie ({ width } x { height }px)"
  },
  "merge_links_2478df96": {
    "message": "Scal łącza"
  },
  "mic_a7f3d311": {
    "message": "Mikrofon"
  },
  "microphone_disabled_15c83130": {
    "message": "Wyłączono mikrofon"
  },
  "middle_27dc1d5": {
    "message": "Środkowy"
  },
  "minimize_file_preview_da911944": {
    "message": "Minimalizuj podgląd pliku"
  },
  "minimize_video_20aa554b": {
    "message": "Minimalizuj okno wideo"
  },
  "minus_fd961e2e": {
    "message": "Minus"
  },
  "minus_plus_3461f637": {
    "message": "Minus/Plus"
  },
  "misc_3b692ea7": {
    "message": "Różne"
  },
  "miscellaneous_e9818229": {
    "message": "Różne"
  },
  "module_90d9fd32": {
    "message": "Moduł"
  },
  "modules_c4325335": {
    "message": "Moduły"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Przenoszenie obrazu do przycięcia { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Obraz wielokolorowy"
  },
  "multiplication_sign_15f95c22": {
    "message": "Znak mnożenia"
  },
  "music_icon_4db5c972": {
    "message": "Ikona muzyki"
  },
  "my_files_2f621040": {
    "message": "Moje pliki"
  },
  "n_th_root_9991a6e4": {
    "message": "Pierwiastek n-tego stopnia"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Nazwa"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Kasownik (muzyka)"
  },
  "natural_numbers_3da07060": {
    "message": "Liczby naturalne"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Przejdź w menu lub na pasku narzędzi"
  },
  "navigation_ee9af92d": {
    "message": "Nawigacja"
  },
  "nested_greater_than_d852e60d": {
    "message": "Zagnieżdżone większe niż"
  },
  "nested_less_than_27d17e58": {
    "message": "Zagnieżdżone mniejsze niż"
  },
  "new_quiz_34aacba6": {
    "message": "Nowy test"
  },
  "next_40e12421": {
    "message": "Następny"
  },
  "next_findtext_9d69f0fe": {
    "message": "Następny { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Nie wykryto problemów z dostępnością."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Nie utworzono jeszcze żadnych ogłoszeń."
  },
  "no_announcements_found_20185afc": {
    "message": "Nie odnaleziono ogłoszeń."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Nie utworzono jeszcze żadnych zadań."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Nie odnaleziono zadań."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Brak zmian do zapisania"
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Nie utworzono jeszcze żadnych dyskusji."
  },
  "no_discussions_found_9284063b": {
    "message": "Nie odnaleziono dyskusji."
  },
  "no_e16d9132": {
    "message": "Nie"
  },
  "no_file_chosen_9a880793": {
    "message": "Nie wybrano pliku"
  },
  "no_headers_9bc7dc7f": {
    "message": "Brak nagłówków"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Nie utworzono jeszcze żadnych modułów."
  },
  "no_modules_found_2df43a40": {
    "message": "Nie odnaleziono modułów."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Nie utworzono jeszcze żadnych stron."
  },
  "no_pages_found_6799350": {
    "message": "Nie odnaleziono stron."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Nie ma możliwości podglądu tego pliku."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Nie utworzono jeszcze żadnych testów."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Nie odnaleziono testów."
  },
  "no_results_940393cf": {
    "message": "Brak wyników."
  },
  "no_results_found_58717065": {
    "message": "Brak wyników"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Nie znaleziono wyników dla { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Brak wideo"
  },
  "none_3b5e34d2": {
    "message": "Brak"
  },
  "none_selected_b93d56d2": {
    "message": "Nie wybrano żadnego"
  },
  "normal_text_7b03da48": {
    "message": "Normalny tekst"
  },
  "not_equal_6e2980e6": {
    "message": "Nie jest równe"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Nie znajduje się w (nie jest elementem)"
  },
  "not_negation_1418ebb8": {
    "message": "Nie (Negacja)"
  },
  "not_subset_dc2b5e84": {
    "message": "Nie jest podzbiorem"
  },
  "not_subset_strict_23d282bf": {
    "message": "Nie jest podzbiorem (ścisłym)"
  },
  "not_superset_5556b913": {
    "message": "Nie jest nadzbiorem"
  },
  "not_superset_strict_24e06f36": {
    "message": "Nie jest nadzbiorem (ścisłym)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "Ośmiobok"
  },
  "olive_6a3e4d6b": {
    "message": "Oliwkowy"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "Aby zapisać ikonę, należy dodać jeden z następujących stylów: Kolor ikony, Rozmiar konturu, Tekst ikony lub Obraz"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Nie udało się wkleić co najmniej jednego pliku. Spróbuj przesłać lub przeciągnąć i upuścić pliki."
  },
  "open_circle_e9bd069": {
    "message": "Otwarty okrąg"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Otwórz to okno dialogowe skrótów klawiatury"
  },
  "open_title_application_fd624fc5": {
    "message": "Otwórz aplikację { title }"
  },
  "operators_a2ef9a93": {
    "message": "Operatory"
  },
  "options_3ab0ea65": {
    "message": "Opcje"
  },
  "or_9b70ccaa": {
    "message": "Lub"
  },
  "orange_81386a62": {
    "message": "Pomarańczowy"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Listy uporządkowane i nieuporządkowane"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Skróty do innych edytorów można znaleźć na"
  },
  "outline_color_3ef2cea7": {
    "message": "Kolor konturu"
  },
  "outline_size_a6059a21": {
    "message": "Rozmiar konturu"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } nie jest prawidłowym protokołem."
  },
  "page_50c4823d": {
    "message": "Strona"
  },
  "pages_e5414c2c": {
    "message": "Strony"
  },
  "paragraph_5e5ad8eb": {
    "message": "Akapit"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Zastosowano akapit"
  },
  "paragraph_removed_d09320e": {
    "message": "Usunięto akapit"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Akapit rozpoczynający się od { start }"
  },
  "parallel_d55d6e38": {
    "message": "Równoległość"
  },
  "partial_derivative_4a9159df": {
    "message": "Pochodna cząstkowa"
  },
  "pass_1c19a2b3": {
    "message": "ZALICZENIE"
  },
  "paste_5963d1c1": {
    "message": "Wklej"
  },
  "pause_12af3bb4": {
    "message": "Pauza"
  },
  "pentagon_17d82ea3": {
    "message": "Pięciokąt"
  },
  "people_b4ebb13c": {
    "message": "Ludzie"
  },
  "percentage_34ab7c2c": {
    "message": "Wartość procentowa"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Odsetek musi być liczbą"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "Wymagane co najmniej { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Ikona sztuk wizualnych"
  },
  "perpendicular_7c48ede4": {
    "message": "Prostopadłość"
  },
  "phi_4ac33b6d": {
    "message": "Fi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Fi (wariant)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Ikona wychowania fizycznego"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (wariant)"
  },
  "pick_a_color_557abfb0": {
    "message": "Wybierz kolor"
  },
  "pink_68ad45cb": {
    "message": "Różowy"
  },
  "pixels_52ece7d1": {
    "message": "Piksele"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Wymagane co najmniej { width } x { height } px"
  },
  "play_1a47eaa7": {
    "message": "Odtwórz"
  },
  "play_media_comment_35257210": {
    "message": "Odtwórz komentarz multimedialny."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Odtwórz komentarz multimedialny { name } z { createdAt }."
  },
  "player_layout_14e09a29": {
    "message": "Układ odtwarzacza"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Zezwól Canvas na łączenie się z kamerą sieciową i mikrofonem."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Wybierz plik"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Wpisz nazwę pliku"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Wprowadź prawidłowy adres URL wideo z obsługiwanej platformy."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Wybierz plik obsługiwanego typu"
  },
  "plus_d43cd4ec": {
    "message": "Plus"
  },
  "plus_minus_f8be2e83": {
    "message": "Plus/Minus"
  },
  "posted_when_a578f5ab": {
    "message": "Opublikował(a): { when }"
  },
  "power_set_4f26f316": {
    "message": "Zbiór potęgowy"
  },
  "precedes_196b9aef": {
    "message": "Poprzedza"
  },
  "precedes_equal_20701e84": {
    "message": "Poprzedza lub równa się"
  },
  "preformatted_d0670862": {
    "message": "Wstępnie formatowane"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Poprz"
  },
  "preview_53003fd2": {
    "message": "Podgląd"
  },
  "preview_a3f8f854": {
    "message": "PODGLĄD"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Podgląd w nakładce"
  },
  "preview_inline_9787330": {
    "message": "Wbudowany pogląd"
  },
  "previous_bd2ac015": {
    "message": "Poprzednie"
  },
  "previous_findtext_8dfbfd30": {
    "message": "Poprzednie { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Wcześniej wybrane kolory"
  },
  "prime_917ea60e": {
    "message": "Liczba pierwsza"
  },
  "prime_numbers_13464f61": {
    "message": "Liczby pierwsze"
  },
  "product_39cf144f": {
    "message": "Produkt"
  },
  "proportional_f02800cc": {
    "message": "Proporcja"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Wymagany jest protokół ftp, http, https, mailto, skype, tel lub można go pominąć"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "opublikowane"
  },
  "published_when_302d8e23": {
    "message": "Opublikowane: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Dynia"
  },
  "purple_7678a9fc": {
    "message": "Fioletowy"
  },
  "quaternions_877024e0": {
    "message": "Kwaterniony"
  },
  "quiz_e0dcce8f": {
    "message": "Quiz"
  },
  "quizzes_7e598f57": {
    "message": "Testy"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Liczby wymierne"
  },
  "real_numbers_7c99df94": {
    "message": "Liczby rzeczywiste"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Część rzeczywista (liczby zespolonej)"
  },
  "record_7c9448b": {
    "message": "Nagraj"
  },
  "record_upload_media_5fdce166": {
    "message": "Utwórz/prześlij pliki multimedialne"
  },
  "recording_98da6bda": {
    "message": "Nagranie"
  },
  "red_8258edf3": {
    "message": "Czerwony"
  },
  "relationships_6602af70": {
    "message": "Powiązania"
  },
  "religion_icon_246e0be1": {
    "message": "Ikona religii"
  },
  "remove_f47dc62a": {
    "message": "Usuń"
  },
  "remove_filename_3ea029f6": {
    "message": "Usuń { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Usuń styl nagłówka"
  },
  "remove_link_d1f2f4d0": {
    "message": "Usuń łącze"
  },
  "replace_all_d3d68b3": {
    "message": "Zamień wszystko"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Zamień wszystkie { findText } na { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Zastąp"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Zamień { findText } na { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Zastąp"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "Zamieniono { alertFindText } na { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Zamieniono wszystkie { alertFindText } na { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Resetuj"
  },
  "resize_ec83d538": {
    "message": "Zmień rozmiar"
  },
  "restore_auto_save_deccd84b": {
    "message": "Przywrócić automatycznie zapisaną zawartość?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Wynik { index } z { max }."
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Kołowrót zwrotny (nie spełnia)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (wariant)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Edytor wzbogaconej zawartości"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Obszar tekstu sformatowanego Naciśnij { OSKey }+F8, aby wyświetlić skróty edytora tekstu sformatowanego."
  },
  "right_71ffdc4d": {
    "message": "Prawa"
  },
  "right_align_39e7a32a": {
    "message": "Wyrównaj do prawej"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Prawy nawias ostrokątny"
  },
  "right_arrow_35e0eddf": {
    "message": "Strzałka w prawo"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Strzałka w prawo zawinięta"
  },
  "right_ceiling_839dc744": {
    "message": "Prawy sufit"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Prawa klamra okrągła"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Strzała harpuna w prawo w dół"
  },
  "right_floor_5392d5cf": {
    "message": "Prawa podłoga"
  },
  "right_to_left_9cfb092a": {
    "message": "Prawa-lewa"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Strzała harpuna w prawo do góry"
  },
  "rightward_arrow_32932107": {
    "message": "Strzałka skierowana w prawo"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Trójkąt skierowany w prawo"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Obróć obraz -90 stopni"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Obróć obraz 90 stopni"
  },
  "rotation_9699c538": {
    "message": "Obrót"
  },
  "row_fc0944a7": {
    "message": "Wiersz"
  },
  "row_group_979f5528": {
    "message": "Grupa wierszy"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Niestety ulepszony edytor HTML nie jest dostępny z poziomu klawiatury. Tutaj możesz uzyskać dostęp do edytor HTML bez formatowania."
  },
  "save_11a80ec3": {
    "message": "Zapisz"
  },
  "save_copy_ca63944e": {
    "message": "Zapisz kopię"
  },
  "save_media_cb9e786e": {
    "message": "Zapisz multimedia"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Zapisane ikony Icon Maker"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Czytniki ekranu nie mogą określić, co jest wyświetlone na obrazie bez alternatywnego tekstu, a nazwy plików są często pozbawionymi znaczenia ciągami cyfr i liter, które nie opisują kontekstu."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Czytniki ekranu nie mogą określić, co jest wyświetlone na obrazie bez alternatywnego tekstu, który opisywałby zawartość i znaczenie obrazu. Tekst alternatywny powinien być prosty i zwięzły."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Czytniki ekranu nie mogą określić, co jest wyświetlone na obrazie bez alternatywnego tekstu, który opisywałby zawartość i znaczenie obrazu."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Czytniki ekranu nie mogą interpretować tabel bez odpowiedniej struktury. Nagłówki tabel zapewniają wskazówki i wskazują na zakres zawartości."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Czytniki ekranu nie mogą interpretować tabel bez odpowiedniej struktury. Napisy w tabelach opisują kontekst i ogólne przesłanie tabeli."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Czytniki ekranu nie mogą interpretować tabel bez odpowiedniej struktury. Nagłówki tabeli zapewniają wskazówki i streszczenie zawartości."
  },
  "script_l_42a7b254": {
    "message": "L ręczne"
  },
  "search_280d00bd": {
    "message": "Wyszukaj"
  },
  "select_audio_source_21043cd5": {
    "message": "Wybierz źródło audio"
  },
  "select_crop_shape_d441feeb": {
    "message": "Wybierz przycięty fragment"
  },
  "select_language_7c93a900": {
    "message": "Wybierz język"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Wybierz źródło wideo"
  },
  "selected_274ce24f": {
    "message": "Wybrano"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Wybrano { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Wybór"
  },
  "set_header_scope_8c548f40": {
    "message": "Ustaw zakres nagłówka"
  },
  "set_minus_b46e9b88": {
    "message": "Różnica zbiorów"
  },
  "set_table_header_cfab13a0": {
    "message": "Ustaw nagłówek tabeli"
  },
  "sharp_music_ab956814": {
    "message": "Krzyżyk (muzyka)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+klawisze strzałek"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Naciśnij Shift-O, aby otworzyć ulepszony edytor HTML."
  },
  "shortcut_911d6255": {
    "message": "Skrót"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Pokaż opcje obrazów"
  },
  "show_link_options_545338fd": {
    "message": "Pokaż opcje łącza"
  },
  "show_rolling_transcript_c1481744": {
    "message": "Pokaż przewijaną transkrypcję"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "Pokaż przewijaną transkrypcję"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Użytkownicy z dobrym wzrokiem szybciej przeglądają strony internetowe, odszukując duże lub zapisane pogrubioną czcionką nagłówki. Użytkownicy czytników ekranu polegają na nagłówkach dla zrozumienia kontekstu. Nagłówki muszą wykorzystywać odpowiednią strukturę."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Użytkownicy z dobrym wzrokiem szybciej przeglądają strony internetowe, odszukując duże lub zapisane pogrubioną czcionką nagłówki. Użytkownicy czytników ekranu polegają na nagłówkach dla zrozumienia kontekstu. Nagłówki w prawidłowej strukturze muszą być zwięzłe."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (wariant)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Obraz jednokolorowy"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Kolor obrazu jednokolorowego"
  },
  "size_b30e1077": {
    "message": "Rozmiar"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "Rozmiar pliku z napisami przekracza maksymalną dozwoloną wartość { max } kb."
  },
  "small_b070434a": {
    "message": "Mały"
  },
  "small_width_x_height_px_359acd38": {
    "message": "Małe ({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "Pełny okrąg"
  },
  "something_went_wrong_89195131": {
    "message": "Coś poszło nie tak."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Wystąpił problem z dostępem do kamery sieciowej."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Wystąpił błąd i nie wiadomo, co wyświetlić."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Coś poszło nie tak. Sprawdź połączenie, odśwież stronę i spróbuj ponownie."
  },
  "something_went_wrong_d238c551": {
    "message": "Coś poszło nie tak"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Wystąpił błąd podczas udostępniania ekranu."
  },
  "sort_by_e75f9e3e": {
    "message": "Sortuj wg"
  },
  "spades_suit_b37020c2": {
    "message": "Piki (kolor)"
  },
  "square_511eb3b3": {
    "message": "Kwadrat"
  },
  "square_cap_9ec88646": {
    "message": "Kwadratowa czapka"
  },
  "square_cup_b0665113": {
    "message": "Kwadratowy kubek"
  },
  "square_root_e8bcbc60": {
    "message": "Pierwiastek kwadratowy"
  },
  "square_root_symbol_d0898a53": {
    "message": "Pierwiastek kwadratowy - symbol"
  },
  "square_subset_17be67cb": {
    "message": "Podzbiór kwadratowy"
  },
  "square_subset_strict_7044e84f": {
    "message": "Podzbiór kwadratowy (ścisły)"
  },
  "square_superset_3be8dae1": {
    "message": "Nadzbiór kwadratowy"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Nadzbiór kwadratowy (ścisły)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "prostokątna nieuporządkowana lista"
  },
  "star_8d156e09": {
    "message": "Gwiazdka"
  },
  "start_over_f7552aa9": {
    "message": "Rozpocznij ponownie"
  },
  "start_recording_9a65141a": {
    "message": "Rozpocznij nagrywanie"
  },
  "steel_blue_14296f08": {
    "message": "Stalowy niebieski"
  },
  "studio_media_options_ee504361": {
    "message": "Opcje multimediów Studio"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Panel opcji multimediów Studio"
  },
  "styles_2aa721ef": {
    "message": "Style"
  },
  "submit_a3cc6859": {
    "message": "Prześlij"
  },
  "submitting_b90fac62": {
    "message": "Przesyłanie..."
  },
  "subscript_59744f96": {
    "message": "Indeks dolny"
  },
  "subset_19c1a92f": {
    "message": "Podzbiór"
  },
  "subset_strict_8d8948d6": {
    "message": "Podzbiór (ścisły)"
  },
  "succeeds_9cc31be9": {
    "message": "Następuje po"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Następuje po lub równa się"
  },
  "sum_b0842d31": {
    "message": "Suma"
  },
  "superscript_8cb349a2": {
    "message": "Indeks górny"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Indeks górny i dolny"
  },
  "superset_c4db8a7a": {
    "message": "Nadzbiór"
  },
  "superset_strict_c77dd6d2": {
    "message": "Nadzbiór (ścisły)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Obsługiwane typy plików: SRT lub WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Przełącz na edytor przetworzonego HTML"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Przełącz na edytor nieprzetworzonego HTML"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Przełącz się do edytora html"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Przełącz na edytor tekstu sformatowanego"
  },
  "syllabus_f191f65b": {
    "message": "Program"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Zezwolono na dźwięk systemu"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Wyłączono dźwięk systemu"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/klawisze strzałek"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Nagłówek tabeli rozpoczynający się od { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Tabela rozpoczynająca się od { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Nagłówki tabeli powinny określać zakres."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Tabele powinny obejmować opis zawartości tabeli."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Tabele powinny zawierać co najmniej jeden nagłówek."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Morski"
  },
  "text_7f4593da": {
    "message": "Tekst"
  },
  "text_background_color_16e61c3f": {
    "message": "Kolor tła tekstu"
  },
  "text_color_acf75eb6": {
    "message": "Kolor tekstu"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "Tekst jest trudny do czytania bez wystarczającego kontrastu między tekstem i tłem, szczególnie w przypadku osób ze słabym wzrokiem."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "Tekst o czcionce powyżej 18 pt (lub pogrubionej 14 pt) powinien korzystać ze współczynnika kontrastu co najmniej 3:1."
  },
  "text_optional_384f94f7": {
    "message": "Tekst (opcjonalny)"
  },
  "text_position_8df8c162": {
    "message": "Położenie tekstu"
  },
  "text_size_887c2f6": {
    "message": "Rozmiar tekstu"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "Tekst o czcionce poniżej 18 pt (lub pogrubionej 14 pt) powinien korzystać ze współczynnika kontrastu co najmniej 4,5:1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Podgląd dokumentu jest teraz przetwarzany. Spróbuj ponownie później."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "Pierwszym nagłówkiem na stronie powinien być H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "Wysokość obszaru zawartości formatowanej zmalała."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "Wysokość obszaru zawartości formatowanej wzrosła."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Materiał znajduje się w domenie publicznej"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Materiał jest objęty licencją Creative Commons"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "Materiały są objęte wyjątkowymi zasadami, np. zasadami dozwolonego użytku, prawa do cytowania lub innymi obowiązującymi przepisami prawa autorskiego"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "Ulepszony edytor HTML nie jest dostępny z poziomu klawiatury. Naciśnij Shift O, aby otworzyć edytor html bez formatowania."
  },
  "therefore_d860e024": {
    "message": "Dlatego"
  },
  "theta_ce2d2350": {
    "message": "Theta"
  },
  "theta_variant_fff6da6f": {
    "message": "Theta (wariant)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Strzałka w dół pogrubiona"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Strzałka w lewo pogrubiona"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Strzałka w kierunku lewym"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Strzałka w prawo pogrubiona"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Strzałka w kierunku prawym pogrubiona"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Strzałka w kierunku górnym pogrubiona"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Nie można wyświetlić tego dokumentu w systemie Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Nie można odtworzyć równania w widoku podstawowym."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Obecnie ten obraz jest niedostępny"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "To wideo może wyświetlać reklamy YouTube."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Chociaż nagranie wideo będzie mieć prawidłowy tytuł w przeglądarce, nie udało się go zaktualizować w bazie danych."
  },
  "thumbnail_e0de666f": {
    "message": "Miniaturka"
  },
  "timebar_a4d18443": {
    "message": "Oś czasu"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "Tytuł nie może być pusty"
  },
  "title_ee03d132": {
    "message": "Tytuł"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "Do opublikowania: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Lista zadań: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Przełącz grupę { summary }"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Etykieta przełącznika"
  },
  "tools_2fcf772e": {
    "message": "Narzędzia"
  },
  "top_66e0adb6": {
    "message": "Góra"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "Panel transkrypcji jest dostępne dla szerokości powyżej 720px."
  },
  "tray_839df38a": {
    "message": "Zasobnik"
  },
  "triangle_6072304e": {
    "message": "Trójkąt"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Kołowrót (spełnia)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "Wpisz Control F9, aby uzyskać dostęp do opcji obrazu. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "Wpisz Control F9, aby uzyskać dostęp do opcji łącza. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "Wpisz Control F9, aby uzyskać dostęp do opcji tabeli. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Nie udało się określić adresu URL wyboru zasobów"
  },
  "underline_applied_ae01ec97": {
    "message": "Zastosowano podkreślenie"
  },
  "underline_removed_3693e17c": {
    "message": "Usunięto podkreślenie"
  },
  "union_e6b57a53": {
    "message": "Suma zbiorów"
  },
  "unpublished_dfd8801": {
    "message": "nieopublikowane"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "Niezapisane zmiany zostaną utracone."
  },
  "untitled_16aa4f2b": {
    "message": "Bez tytułu"
  },
  "untitled_efdc2d7d": {
    "message": "bez tytułu"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Strzałka po przekątnej do góry i w lewo"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Strzałka po przekątnej do góry i w prawo"
  },
  "up_c553575d": {
    "message": "Do góry"
  },
  "updated_link_a827e441": {
    "message": "Zaktualizowane łącze"
  },
  "upload_document_253f0478": {
    "message": "Prześlij dokument"
  },
  "upload_file_fd2361b8": {
    "message": "Prześlij plik"
  },
  "upload_image_6120b609": {
    "message": "Prześlij obraz"
  },
  "upload_media_ce31135a": {
    "message": "Przekaż pliki multimedialne"
  },
  "upload_record_media_e4207d72": {
    "message": "Przekaż/zapisz pliki multimedialne"
  },
  "uploading_19e8a4e7": {
    "message": "Przekazywanie"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "uporządkowana lista alfabetyczna, duże litery"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Duża delta"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Duża gamma"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Duża lambda"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Duża omega"
  },
  "uppercase_phi_caa36724": {
    "message": "Duże fi"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Duże pi"
  },
  "uppercase_psi_6395acbe": {
    "message": "Duże psi"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "uporządkowania lista numeryczna, duże cyfry rzymskie"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Duża sigma"
  },
  "uppercase_theta_49afc891": {
    "message": "Duża theta "
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Duży ipsylon"
  },
  "uppercase_xi_341e8556": {
    "message": "Duże ksi"
  },
  "upsilon_33651634": {
    "message": "Ipsylon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Strzałka skierowana do góry i w dół"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Strzałka skierowana do góry i w dół (pogrubiona)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Strzałka skierowana do góry"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Trójkąt skierowany do góry"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Prawo użytkowania:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Prawo użytkowania (wymagane)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Użyj klawiszy strzałek do nawigowania po opcjach."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Użyj klawiszy strzałek, aby wybrać kształt."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Użyj klawiszy strzałek, aby wybrać rozmiar."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Użyj klawiszy strzałek, aby wybrać położenie tekstu."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Użyj klawiszy strzałek, aby wybrać rozmiar tekstu."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Użyj klawiszy strzałek, aby wybrać rozmiar obramowania."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Używane przez czytniki ekranu do opisania zawartości { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Używane przez czytniki ekranu do opisania zawartości obrazu"
  },
  "user_documents_c206e61f": {
    "message": "Dokumenty użytkownika"
  },
  "user_files_78e21703": {
    "message": "Pliki użytkownika"
  },
  "user_images_b6490852": {
    "message": "Zdjęcia użytkownika"
  },
  "user_media_14fbf656": {
    "message": "Multimedia użytkownika"
  },
  "vector_notation_cf6086ab": {
    "message": "Wektor (notacja)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Kreska pionowa (notacja budująca zbiory)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Kropki pionowo"
  },
  "video_options_24ef6e5d": {
    "message": "Opcje wideo"
  },
  "video_options_tray_3b9809a5": {
    "message": "Panel opcji wideo"
  },
  "video_player_b371005": {
    "message": "Odtwarzacz wideo"
  },
  "video_player_for_9e7d373b": {
    "message": "Odtwarzacz wideo dla "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Odtwarzacz wideo dla { title }"
  },
  "video_url_889d3263": {
    "message": "Adres URL wideo"
  },
  "view_all_e13bf0a6": {
    "message": "Wyświetl wszystkie"
  },
  "view_ba339f93": {
    "message": "Wyświetl"
  },
  "view_description_30446afc": {
    "message": "Wyświetl opis"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Wyświetl skróty klawiszowe"
  },
  "view_title_description_67940918": {
    "message": "Wyświetl opis { title }"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Wyświetl liczbę słów i znaków"
  },
  "viewer_restrictions_e14274c9": {
    "message": "Ograniczenia dla wyświetlających"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Nie udało się wykryć działającego mikrofonu podłączonego do urządzenia."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Nie udało się wykryć działającej kamery podłączonej do urządzenia."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Nie udało się wykryć działającej kamery ani mikrofonu podłączonych do urządzenia."
  },
  "webcam_disabled_30c66986": {
    "message": "Wyłączono kamerę internetową"
  },
  "webcam_fe91b20f": {
    "message": "Kamera sieciowa"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Strony internetowe powinny mieć tylko jeden nagłówek H1, który jest automatycznie używany przez tytuł strony. Pierwszym nagłówkiem zawartości powinien być H2."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Gdy używane jest oznaczenie, które wizualnie formatuje elementy jako listę, ale nie wskazuje na relacje w liście, użytkownicy mogą mieć problem z nawigowaniem po informacjach."
  },
  "white_87fa64fd": {
    "message": "Biały"
  },
  "why_523b3d8c": {
    "message": "Dlaczego"
  },
  "width_492fec76": {
    "message": "Szerokość"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Szerokość i wysokość muszą być liczbami"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "Wiki — Strona główna"
  },
  "word_count_c77fe3a6": {
    "message": "Liczba słów"
  },
  "words_b448b7d5": {
    "message": "Słowa"
  },
  "wreath_product_200b38ef": {
    "message": "Produkt splotowy"
  },
  "xi_149681d0": {
    "message": "Ksi"
  },
  "yes_dde87d5": {
    "message": "Tak"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Korzystasz z palety kolorów. Aby przewijać paletę w górę i w dół, w prawo lub w lewo, użyj klawiszy W, A, S i D."
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Korzystasz z suwaka kolorów. Aby przesunąć suwak w prawo lub w lewo, użyj klawiszy A i D."
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Korzystasz z suwaka alfa. Aby przesunąć suwak w prawo lub w lewo, użyj klawiszy A i D."
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Masz niezapisane zmiany w panelu Icon Maker. Czy chcesz kontynuować bez zapisywania tych zmian?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Może być konieczne dostosowanie dodatkowych nagłówków w celu zachowania hierarchii elementów na stronie."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Nie można przesłać pustego pliku."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Obraz został skompresowany dla programu Icon Maker. Obrazy mniejsze niż { size } kB nie zostaną skompresowane."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Mikrofon został zablokowany w ustawieniach przeglądarki."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Mikrofon i kamera zostały zablokowane w ustawieniach przeglądarki."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Kamera została zablokowana w ustawieniach przeglądarki."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Kamera sieciowa może być już w użyciu."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "Osadź adres URL z serwisu YouTube"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Przybliż obraz"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Oddal obraz"
  }
};
formatMessage.addLocale({
  pl: locale
});